// store/admin/college-management/store/_actions.js

import * as types from './_actionTypes';

// Fetch Colleges Actions
export const fetchCollegesRequest = (params = {}) => ({
  type: types.FETCH_COLLEGES_REQUEST,
  payload: params
});

export const fetchCollegesSuccess = (colleges) => ({
  type: types.FETCH_COLLEGES_SUCCESS,
  payload: colleges
});

export const fetchCollegesFailure = (error) => ({
  type: types.FETCH_COLLEGES_FAILURE,
  payload: error
});

export const fetchDegreesForCollegeRequest = (collegeId) => ({
  type: types.FETCH_DEGREES_FOR_COLLEGE_REQUEST,
  payload: collegeId
});
export const fetchDegreesForCollegeSuccess = ( degrees) => ({
  type: types.FETCH_DEGREES_FOR_COLLEGE_SUCCESS,
  payload:  degrees 
});
export const fetchDegreesForCollegeFailure = (error, collegeId) => ({
  type: types.FETCH_DEGREES_FOR_COLLEGE_FAILURE,
  payload: error,
  meta: collegeId ? { collegeId } : undefined
});
// Create College Actions
export const createCollegeRequest = (collegeData) => ({
  type: types.CREATE_COLLEGE_REQUEST,
  payload: collegeData
});

export const createCollegeSuccess = (college) => ({
  type: types.CREATE_COLLEGE_SUCCESS,
  payload: college
});

export const createCollegeFailure = (error) => ({
  type: types.CREATE_COLLEGE_FAILURE,
  payload: error
});

// Update College Actions
export const updateCollegeRequest = (collegeId, updateData) => ({
  type: types.UPDATE_COLLEGE_REQUEST,
  payload: { collegeId, updateData }
});

export const updateCollegeSuccess = (college) => ({
  type: types.UPDATE_COLLEGE_SUCCESS,
  payload: college
});

export const updateCollegeFailure = (error) => ({
  type: types.UPDATE_COLLEGE_FAILURE,
  payload: error
});

// Approve College Actions
export const approveCollegeRequest = (collegeId) => ({
  type: types.APPROVE_COLLEGE_REQUEST,
  payload: collegeId
});

export const approveCollegeSuccess = (collegeId) => ({
  type: types.APPROVE_COLLEGE_SUCCESS,
  payload: collegeId
});

export const approveCollegeFailure = (error, collegeId) => ({
  type: types.APPROVE_COLLEGE_FAILURE,
  payload: error,
  meta: collegeId ? { collegeId } : undefined
});

// Suspend College Actions
export const suspendCollegeRequest = (collegeId) => ({
  type: types.SUSPEND_COLLEGE_REQUEST,
  payload: collegeId
});

export const suspendCollegeSuccess = (collegeId) => ({
  type: types.SUSPEND_COLLEGE_SUCCESS,
  payload: collegeId
});

export const suspendCollegeFailure = (error, collegeId) => ({
  type: types.SUSPEND_COLLEGE_FAILURE,
  payload: error,
  meta: collegeId ? { collegeId } : undefined
});


export const toggleCollegeSubscriptionRequest = (collegeId) => ({
  type: types.TOGGLE_COLLEGE_SUBSCRIPTION_REQUEST,
  payload: collegeId
});

export const toggleCollegeSubscriptionSuccess = (collegeId, subscriptionActive) => ({
  type: types.TOGGLE_COLLEGE_SUBSCRIPTION_SUCCESS,
  payload: { collegeId, subscriptionActive }
});

export const toggleCollegeSubscriptionFailure = (error, collegeId) => ({
  type: types.TOGGLE_COLLEGE_SUBSCRIPTION_FAILURE,
  payload: error,
  meta: { collegeId }
});

// Delete College Actions
export const deleteCollegeRequest = (collegeId) => ({
  type: types.DELETE_COLLEGE_REQUEST,
  payload: collegeId
});

export const deleteCollegeSuccess = (collegeId) => ({
  type: types.DELETE_COLLEGE_SUCCESS,
  payload: collegeId
});

export const deleteCollegeFailure = (error, collegeId) => ({
  type: types.DELETE_COLLEGE_FAILURE,
  payload: error,
  meta: collegeId ? { collegeId } : undefined
});

// Search Colleges Actions
export const searchCollegesRequest = (searchParams) => ({
  type: types.SEARCH_COLLEGES_REQUEST,
  payload: searchParams
});

export const searchCollegesSuccess = (colleges) => ({
  type: types.SEARCH_COLLEGES_SUCCESS,
  payload: colleges
});

export const searchCollegesFailure = (error) => ({
  type: types.SEARCH_COLLEGES_FAILURE,
  payload: error
});

// Get College Statistics Actions
export const getCollegeStatisticsRequest = () => ({
  type: types.GET_COLLEGE_STATISTICS_REQUEST
});

export const getCollegeStatisticsSuccess = (statistics) => ({
  type: types.GET_COLLEGE_STATISTICS_SUCCESS,
  payload: statistics
});

export const getCollegeStatisticsFailure = (error) => ({
  type: types.GET_COLLEGE_STATISTICS_FAILURE,
  payload: error
});

// Bulk Approve Colleges Actions
export const bulkApproveCollegesRequest = (collegeIds) => ({
  type: types.BULK_APPROVE_COLLEGES_REQUEST,
  payload: collegeIds
});

export const bulkApproveCollegesSuccess = (result) => ({
  type: types.BULK_APPROVE_COLLEGES_SUCCESS,
  payload: result
});

export const bulkApproveCollegesFailure = (error) => ({
  type: types.BULK_APPROVE_COLLEGES_FAILURE,
  payload: error
});

// Get College By ID Actions
export const getCollegeByIdRequest = (collegeId) => ({
  type: types.GET_COLLEGE_BY_ID_REQUEST,
  payload: collegeId
});

export const getCollegeByIdSuccess = (college) => ({
  type: types.GET_COLLEGE_BY_ID_SUCCESS,
  payload: college
});

export const getCollegeByIdFailure = (error) => ({
  type: types.GET_COLLEGE_BY_ID_FAILURE,
  payload: error
});

// UI State Actions
export const clearCollegeError = () => ({
  type: types.CLEAR_COLLEGE_ERROR
});

export const setCollegeLoading = (loading) => ({
  type: types.SET_COLLEGE_LOADING,
  payload: loading
});

export const resetCollegeState = () => ({
  type: types.RESET_COLLEGE_STATE
});


